<template>
  <div class="p-sub-account">
    <div class="p-sub-account-side-nav">
      <sub-side-nav :id="currentId" />
    </div>
    <div v-loading="loading" class="p-sub-account-management">
      <div class="p-sub-account-management__title">{{ title }}</div>
      <router-view
        @loading="handleLoadingStatus(true)"
        @cancelLoading="handleLoadingStatus(false)"
      />
    </div>
  </div>
</template>

<script>
import SubSideNav from './components/subSideNav/subSideNav';
import loadingMixin from '@/mixins/loading';
export default {
  components: {
    SubSideNav
  },
  mixins: [loadingMixin],

  computed: {
    title() {
      return this.$route.meta.title;
    },
    currentId() {
      return this.$route.params.id;
    }
  },
};
</script>

<style lang="scss" scoped>
.p-sub-account {
  height: 100%;
  display: flex;
  .p-sub-account-side-nav {
    height: 100%;
  }
  .p-sub-account-management {
    flex: 1;
    overflow: scroll;
  }
  .p-sub-account-management__title {
    font-size: 18px;
    font-weight: 500;
    margin: 20px;
  }
}
</style>
